module.exports = __webpack_public_path__ + "static/media/ServiceBWN.cd8a8960.jpg";